<template>
  <div class="detail">
    <div class="detail-head clear-fix">
      <div class="fl disFlex">
        <div class="w100">
          <img :src="data.headImg" width="60" height="60" alt="">
        </div>
        <div class="flex1">
          <p class="font18">{{data.nickName}}</p>
          <p class="mt10">{{data.phone}}</p>
        </div>
      </div>

      <div class="fr">
        <ul class="detail-head-content">
          <li>
            <p class="font22">{{data.browseNum}}</p>
            <p>点击量</p>
          </li>
          <li>
            <p class="font22">{{data.likeNum}}</p>
            <p>点赞数</p>
          </li>
          <li>
            <p class="font22">{{data.collectionNum}}</p>
            <p>收藏数</p>
          </li>
          <li>
            <p class="font22">{{data.commentsNum}}</p>
            <p>评论数</p>
          </li>
          <li>
            <p class="font22">{{data.forwardingNum}}</p>
            <p>转发数</p>
          </li>
        </ul>
      </div>
    </div>

    <el-form label-width="120px">
      <el-form-item label="视频标题：">
        {{data.title}}
      </el-form-item>
      <el-form-item label="视频简介：">
        {{data.content}}
      </el-form-item>
      <el-form-item label="视频内容：">
        <video :src="data.videoUrl" width="350" height="200"></video>
      </el-form-item>
      <el-form-item label="标签：">
        <el-tag class="mr10" size="medium" v-for="(item, index) in data.labelName" :key="index">
          {{item.labelName}}
        </el-tag>
      </el-form-item>
      <el-form-item label="创建时间：">
        {{data.createTime}}
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

  export default {
    props: ['data']
  }
</script>

<style scoped>
  .detail {
    padding-bottom: 50px;
  }

  .detail-head {
    background-color: #ebeef5;
    padding: 20px 30px 20px 70px;
  }

  .detail-head-content > li {
    display: inline-block;
    text-align: center;
    margin-right: 40px;
    line-height: 30px;
  }
</style>
